module.exports = __webpack_public_path__ + "static/media/DSC_6231.36590277.JPG";